import { orderBy } from 'lodash';
import type { BookingHistoryQuery_viewer_bookings_byBookingNo_history } from '../../../../common/graphql/gql/BookingHistoryQuery';
import type { HistoryRow } from '../components/HistoryTable';

export const transformHistoryRows = (
  history: BookingHistoryQuery_viewer_bookings_byBookingNo_history[],
): HistoryRow[] =>
  orderBy(history, ['versionNumber'], ['desc']).map(h => ({
    by: h.modifiedBy,
    status: h.status,
    time: new Date(h.dateModified),
  }));
